import { type FC, useState } from "react";
import { Button, Tooltip } from "@mui/material";
import { CCBILL_REFUND_UNSUPPORTED_MESSAGE } from "../model/ccbillRefundUnsupportedMessage";
import { CreateRefundDialog } from "./CreateRefundDialog";

interface RefundButtonProps {
  paymentId: string;
  provider: string;
  onCompleted?: () => void;
}

// Провайдеры, для которых у нас нет API возврата: кнопка блокируется, а
// текст объясняет, где на самом деле оформлять возврат. Один провайдер —
// одна запись здесь, без повторения ветки в разметке. Paynet из списка
// ушёл с переходом на его ecom-API: возврат делает RefundService.
const REFUND_UNSUPPORTED_MESSAGE_BY_PROVIDER: Record<string, string> = {
  CCBILL: CCBILL_REFUND_UNSUPPORTED_MESSAGE,
};

export const RefundButton: FC<RefundButtonProps> = ({
  paymentId,
  provider,
  onCompleted,
}) => {
  const [open, setOpen] = useState(false);
  const unsupportedMessage = REFUND_UNSUPPORTED_MESSAGE_BY_PROVIDER[provider];
  const isUnsupported = unsupportedMessage !== undefined;

  const button = (
    <Button
      size="small"
      disabled={isUnsupported}
      onClick={(event) => {
        event.stopPropagation();
        setOpen(true);
      }}
    >
      Возврат
    </Button>
  );

  return (
    <>
      {isUnsupported ? (
        <Tooltip title={unsupportedMessage}>
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
      <CreateRefundDialog
        open={open}
        paymentId={paymentId}
        onClose={() => setOpen(false)}
        onCompleted={onCompleted}
      />
    </>
  );
};
